const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  authList: state => state.user.authList,
  logRecord: state => state.app.logRecord,
  layoutAlive: state => state.app.layoutAlive
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js